import * as googleAuthActions from '../actions/googleAuth';

const initialState = {
    qrCode: null,
    googleSecret: null,
    isGeneratingQrCode: false,
    qrCodeGenerateError: false,
    otpVerified: null,
    errors: {}
};

export default (state = initialState, action) => {
    switch (action.type) {

        case googleAuthActions.REFRESH_QR_CODE_GENERATED:
            return {
                ...state,
                qrCode: action.qrCodeData.qr_code,
                googleSecret: action.qrCodeData.secret
            };

        case googleAuthActions.QR_CODE_GENERATING:
            return {
                ...state,
                isGeneratingQrCode: action.isGenerating
            };

        case googleAuthActions.QR_CODE_GENERATE_ERROR:
            return {
                ...state,
                qrCodeGenerateError: true
            };

        case googleAuthActions.RESET_QR_CODE:
            return {
                ...state,
                qrCodeGenerateError: false,
                qrCode: null,
                googleSecret: null,
                otpVerified: null
            };

        case googleAuthActions.GOOGLE_OTP_VERIFIED:
            return {
                ...state,
                otpVerified: action.verified
            };

        case googleAuthActions.SET_GOOGLE_AUTH_ERRORS:
            return {
                ...state,
                errors: action.errors
            };

        case googleAuthActions.CLEAR_GOOGLE_AUTH_ERRORS:
            return {
                ...state,
                errors: {}
            };

        default:
            return state;
    }
};